// extracted by mini-css-extract-plugin
module.exports = {"root":"titledSection_root__v47eH","title":"titledSection_title__1QgN9","content":"titledSection_content__2d-JN"};